import i18next from "i18next";
import { initReactI18next } from "react-i18next";
import translation from "./en/translation.json";
import translation_pl from "./pl/translation.json";

i18next.use(initReactI18next).init({
  lng: "pl", // if you're using a language detector, do not define the lng option
  debug: false,
  interpolation: {
    escapeValue: false, // not needed for react as it escapes by default
  },
  resources: {
    en: {
      translation,
    },
    pl: {
      translation: translation_pl,
    },
  },
});
